"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Website = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function Website(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM12.6133 7.33333H10.9C10.8629 6.13154 10.5958 4.94798 10.1133 3.84667C11.4632 4.53423 12.3953 5.83423 12.6133 7.33333ZM8 12.6667H8.3C8.90667 12.2733 9.60667 10.8133 9.72667 8.66667H6.27333C6.36667 10.8267 7.09333 12.2867 7.7 12.6667H8ZM6.3 7.33333C6.42 5.18667 7.12 3.72667 7.72667 3.33333H8H8.3C8.90667 3.71333 9.63333 5.17333 9.72667 7.33333H6.3ZM5.1 7.33333C5.13714 6.13154 5.40417 4.94798 5.88667 3.84667C4.53681 4.53423 3.60469 5.83423 3.38667 7.33333H5.1ZM3.38667 8.66667H5.1C5.13714 9.86846 5.40417 11.052 5.88667 12.1533C4.53681 11.4658 3.60469 10.1658 3.38667 8.66667ZM10.9 8.66667C10.8629 9.86846 10.5958 11.052 10.1133 12.1533C11.4632 11.4658 12.3953 10.1658 12.6133 8.66667H10.9Z",
    fill: "currentColor"
  }));
}

exports.Website = Website;